import React from "react";
import { useNavigate } from "react-router-dom";

const WelcomeScreen = () => {
  const navigate = useNavigate();

  const handleOptionClick = (option) => {
    if (option === "worker") {
      navigate("/account/admin-dashboard/users/worker-users");
    } else if (option === "client") {
      navigate("/account/admin-dashboard/users/client-users");
    }
  };

  return (
    <div className="welcome-screen">
      <div className="options-container">
        <div
          className="option worker-option"
          onClick={() => handleOptionClick("worker")}
        >
          Worker Users
        </div>
        <div
          className="option client-option"
          onClick={() => handleOptionClick("client")}
        >
          Client Users
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
